module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qnerv4-8c9e47a977f6c72c28c53ec2f7e36bb7.jpg";